const environment = {
  NODE_ENV: process.env.REACT_APP_NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_API_SITE_URL: process.env.REACT_APP_API_SITE_URL,
  GA_ID: process.env.REACT_APP_GA_ID || "",
  GTM_ID: process.env.REACT_APP_GTM_ID || "",
};
export default environment;
